export const ACHIEVEMENT_FLAG_ID = 1084